import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import App from "../App";
import Works from "../Pages/Works/Works";
import About from "../Pages/About/About";
import Contact from "../Pages/Contact/Contact";
import Blog from "../Pages/Blog/Blog";
import WorkDescription from "./Work/WorkDescription/WorkDescription";
import { AnimatePresence } from "framer-motion";

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence exitBeforeEnter>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<App />} />
        <Route path="home" element={<App />} />
        <Route path="works" element={<Works />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="blog" element={<Blog />} />
        <Route path="work-description">
          <Route path=":id" element={<WorkDescription />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
